const sectionDelimiter = "***";

export function isSection(item: { value: string }) {
  return (
    item.value.startsWith(sectionDelimiter) &&
    item.value.endsWith(sectionDelimiter)
  );
}

export function removeDelimiter(item: { value: string }) {
  return item.value.substring(
    sectionDelimiter.length,
    item.value.length - sectionDelimiter.length,
  );
}

export function getStepNumber(
  allDirections: { value: string }[],
  index: number,
) {
  let step = 1;
  for (let i = index - 1; i >= 0; i--) {
    if (isSection(allDirections[i])) {
      break;
    } else {
      step++;
    }
  }
  return step;
}
